module.exports = __webpack_public_path__ + "img/ecosystem_01_leftball.1429b382.svg";